import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';
import { ProductsResponse } from '@/features/editor/widgets/custom-widget/loading-section/manual-product-picker/context/model';
import { StorePage } from '@/features/editor/context/use-device-navigation';

export const UPSELLS_APP_ID = `upsells`;

export function useCatalogApi() {
  const { post, loading } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
      loading: true,
    },
  }));

  const listEntireCatalog = (page: number, pageSize: number) =>
    post(routes.listCatalog(), {
      page,
      pageSize,
    }) as Promise<CatalogResponse>;

  const searchCatalog = (query: string, maxResults: number, domain?: string) =>
    post(routes.catalogSearch(), {
      query,
      maxResults,
      domain,
    } as SearchCatalogRequest) as Promise<SearchCatalogResponse>;

  const listProductsByText = (
    page: number,
    size: number,
    options: { query: string },
  ) =>
    post(routes.listRecommendationProducts(), {
      page,
      size,
      query: options?.query || ``,
    } as any) as Promise<ProductsResponse>;

  const listProductsByIds = (productIds: Array<string>) =>
    post(routes.listRecommendationProducts(), {
      page: 0,
      size: 25,
      productIds,
    } as any) as Promise<ProductsResponse>;

  const listProducts = (searchText: string, page?: number) =>
    post(routes.listRecommendationProducts(), {
      page: page || 0,
      size: 25,
      query: searchText,
    } as any) as Promise<ProductsResponse>;

  return {
    loading,
    listEntireCatalog,
    searchCatalog,
    listProductsByText,
    listProductsByIds,
    listProducts,
  };
}

export interface SearchCatalogRequest {
  query: string;
  maxResults: number;
  domain?: string;
}

export interface SearchCatalogResponse {
  pages: StorePage[];
  total: number;
}

export enum StorePageType {
  STORE_PAGE_UNKNOWN = 0,
  STORE_PAGE_HOMEPAGE = 1,
  STORE_PAGE_PRODUCT = 2,
  STORE_PAGE_COLLECTION = 3,
  STORE_PAGE_CART = 4,
  STORE_PAGE_CHECKOUT = 5,
  STORE_PAGE_CUSTOM = 6,
}

export interface CatalogResponse {
  products: Array<Product>;
  collections: Array<Collection>;
  productTags: Array<string>;
  customerTags: Array<string>;
  reviewsEnabled?: boolean;
  currencies: Array<string>;
  productCount: number;
  mainAttribute: string;
  mainAttributeOptions: Array<string>;
}

export interface Collection {
  id: number;
  handle: string;
  title: string;
}

export interface Product {
  id: string;
  collections: string[];
  handle: string;
  product_type: string;
  title: string;
  image: {
    src: string;
    height: number;
    width: number;
  };
  tags: string[];
  rank: number;
  options: ProductOption[];
  variantIds: number[];
}

export interface ProductOption {
  name: string;
  values: string[];
}
